<template>
  <ProductFilter
    :isOnProductDetailPage="isOnProductDetailPage"
    :placeholderText="placeholderText"
    :totalFiltersActive="totalFiltersActive"
    filterType="product"
    title="Product Types"
    tooltipText="For example, belt or hat"
  />
</template>

<script>
  import ProductFilter from '@/components/ProductFilter'

  export default {
    name: 'ProductFilterProductTypes',
    components: {
      ProductFilter
    },
    props: {
      isOnProductDetailPage: Boolean,
      totalFiltersActive: Number
    },
    computed: {
      placeholderText: function () {
        return 'Start typing "Hat"'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ProductFilterProductTypes.vue